<template>
  <div class="app content-1200">
    <div class="main-title fontWeight-800 fontSize36 color-level1 text-center">金标应用</div>
    <div class="app-content" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
      <div class="scroll-container" ref="scrollContainer">
        <div class="column" v-for="(column, colIndex) in displayColumns" :key="colIndex">
          <div class="item" v-for="item in column" :key="item.id">
            <img :src="item.apkIcon" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {singleServiceSever} from "@/common/api-config";

export default {
  data() {
    return {
      appIconList: [], // 所有已加载的数据
      page: 1,
      perPage: 24, // 每次加载9个，保证是3的倍数
      scrollInterval: null,
      scrollSpeed: 10,
      isScrolling: true,
      isLoading: false,
      hasMore: true,
      itemsPerColumn: 3 // 每列显示3个
    };
  },
  computed: {
    // 将数据按列分组
    displayColumns() {
      const columns = [];
      const columnCount = Math.ceil(this.appIconList.length / this.itemsPerColumn);

      for (let i = 0; i < columnCount; i++) {
        const columnItems = [];
        for (let j = 0; j < this.itemsPerColumn; j++) {
          const index = i * this.itemsPerColumn + j;
          if (index < this.appIconList.length) {
            columnItems.push(this.appIconList[index]);
          }
        }
        columns.push(columnItems);
      }

      // 检查最后一列是否不足3个
      const lastColumn = columns[columns.length - 1];
      if (lastColumn && lastColumn.length < this.itemsPerColumn && this.page > 1) {
        // 标记需要补全数据
        this.checkAndCompleteData();
      }
      return columns;
    }
  },
  mounted() {
    this.getAppIcon();
    this.startAutoScroll();
  },
  beforeDestroy() {
    this.stopAutoScroll();
  },
  methods: {
    async getAppIcon() {
      if (this.isLoading || !this.hasMore) return;

      this.isLoading = true;
      try {
        const res = await singleServiceSever.queryAllApk({
          page: this.page,
          perPage: this.perPage,
        });

        if (res.code == 0) {
          const newItems = res.data.data;
          this.appIconList = [...this.appIconList, ...newItems];
          this.hasMore = this.page * this.perPage < res.data.total;
        }
      } finally {
        this.isLoading = false;
      }
    },

    checkAndCompleteData() {
      // 检查是否需要补全最后一列
      const totalItems = this.appIconList.length;
      const remainder = totalItems % this.itemsPerColumn;

      if (remainder !== 0 && this.hasMore && !this.isLoading) {
        // 加载下一页数据补全
        this.page++;
        this.getAppIcon();
      } else if (remainder !== 0 && !this.hasMore) {
        // 没有更多数据了，重新请求第一页补全
        this.page = 1;
        this.getAppIcon();
      }
    },

    startAutoScroll() {
      this.stopAutoScroll();
      const container = this.$refs.scrollContainer;

      this.scrollInterval = setInterval(() => {
        if (!this.isScrolling) return;

        container.scrollLeft += 1;

        // 检查是否接近滚动末尾
        const scrollWidth = container.scrollWidth;
        const scrollLeft = container.scrollLeft;
        const clientWidth = container.clientWidth;
        // 当滚动到70%时加载下一页
        if (scrollLeft + clientWidth >= scrollWidth * 0.7 && this.hasMore && !this.isLoading) {
          this.page++;
          this.getAppIcon();
        }

        // 如果已经滚动到最右边，回到起点
        if (scrollLeft >= scrollWidth - clientWidth) {
          container.scrollLeft = 0;
        }
      }, this.scrollSpeed);
    },

    stopAutoScroll() {
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },

    pauseScroll() {
      this.isScrolling = false;
    },

    resumeScroll() {
      this.isScrolling = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.main-title {
  margin-bottom: 60px;
}

.app {
  padding: 80px 0 120px;

  &-content {
    width: 1200px;
    overflow: hidden;
    cursor: pointer;
    position: relative;

    .scroll-container {
      display: flex;
      height: 420px;
      overflow-x: auto;
      overflow-y: hidden;

      .column {
        display: flex;
        flex-direction: column;
        margin-right: 57px;
        min-width: 100px;

        .item {
          width: 100px;
          height: 100px;
          margin-bottom: 40px;

          &:last-child {
            margin-bottom: 0;
          }

          img {
            width: 100px;
            height: 100px;
            box-shadow: 0 12px 24px -12px rgba(0, 0, 0, 0.1);
            border-radius: 16px;
          }
        }
      }

      &::-webkit-scrollbar {
        display: none;
      }
    }

    &::before, &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 220px;
      z-index: 2;
      pointer-events: none;
    }

    &::before {
      left: 0;
      background: linear-gradient(to right, #FAFAFA 0%, rgba(250, 250, 250, 0) 100%);
    }

    &::after {
      right: 0;
      background: linear-gradient(to left, #FAFAFA 0%, rgba(250, 250, 250, 0) 100%);
    }
  }
}
</style>
